import React from "react";
import { motion } from "framer-motion";
import { MousePointerClick, GitCompareArrows, Clock3, ShieldCheck, BadgeEuro, EyeOff } from "lucide-react";

const BLOCKS = [
  {
    icon: MousePointerClick,
    kicker: "01 · La Semplicità",
    title: "Dichiari una volta, per sempre",
    text: "60 secondi: tipo di immobile (casa, villa, terreno, capannone, negozio), zona, budget e caratteristiche. Basta girare agenzie, ricontrollare ogni giorno gli stessi annunci e fare decine di telefonate. La tua richiesta lavora per te 24 ore su 24.",
  },
  {
    icon: GitCompareArrows,
    kicker: "02 · Il Match stile Tinder",
    title: "È l'offerta che ti trova",
    text: "Il sistema incrocia la tua richiesta con i portafogli di agenzie e proprietari della zona. Se qualcuno ha l'immobile che combacia col tuo budget e le tue richieste, scatta il Match: ti avvisiamo via email e parli direttamente con lui nella chat protetta, senza mostrare subito il tuo numero.",
  },
  {
    icon: ShieldCheck,
    kicker: "03 · I tuoi vantaggi",
    title: "Il Controllo",
    perks: [
      { icon: Clock3, bold: "Tempo e benzina azzerati:", rest: " Niente più giri per agenzie, annunci ricontrollati e telefonate a vuoto: il mercato bussa alla tua porta." },
      { icon: EyeOff, bold: "Scopri l'invisibile:", rest: " Trovi anche immobili mai pubblicati per privacy e proprietari che, vedendo la tua richiesta, decidono di vendere o affittare proprio a te." },
      { icon: BadgeEuro, bold: "100% Gratuito:", rest: " Per chi cerca non costa nulla: chi offre paga per sbloccarti, è il nostro filtro anti-spam." },
    ],
  },
];

export const HowItWorks = () => (
  <section id="come-funziona" className="relative py-20 sm:py-28 bg-white border-y border-slate-200/70 grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-2xl mb-14"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600 mb-4">
          Come funziona &amp; vantaggi
        </p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0A192F]">
          Tu dichiari cosa cerchi. <br className="hidden sm:block" />
          Al resto pensiamo noi.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {BLOCKS.map((b, i) => (
          <motion.article
            key={b.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="group relative rounded-[1.75rem] bg-[#F8F9FA] border border-slate-200/80 p-8 hover:bg-white hover:shadow-[0_20px_50px_rgba(10,25,47,0.08)] hover:-translate-y-1.5 transition-all duration-400"
          >
            <div className="flex items-center justify-between mb-7">
              <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-[#0A192F] text-[#10B981] group-hover:bg-[#10B981] group-hover:text-white transition-colors duration-300">
                <b.icon className="w-5.5 h-5.5" />
              </span>
              <span className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-slate-400">{b.kicker}</span>
            </div>
            <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0A192F] mb-4">{b.title}</h3>
            {b.text && <p className="text-sm sm:text-[15px] text-slate-600 leading-relaxed">{b.text}</p>}
            {b.perks && (
              <ul className="space-y-4">
                {b.perks.map((p) => (
                  <li key={p.bold} className="flex gap-3">
                    <p.icon className="w-4.5 h-4.5 text-[#10B981] shrink-0 mt-0.5" />
                    <p className="text-sm sm:text-[15px] text-slate-600 leading-relaxed">
                      <strong className="text-[#0A192F] font-bold">{p.bold}</strong>
                      {p.rest}
                    </p>
                  </li>
                ))}
              </ul>
            )}
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
